import React, { useContext, useEffect, useState } from 'react';


import { Doughnut } from 'react-chartjs-2';
import BoxContainer from '../../../components/boxcontainer';
import ModalFilters, { SeparatorFilter } from '../../../components/modalfilters';
import moment from 'moment';
import InputDate from '../../../components/inputdate';
import { CustumerContext } from "../../../contexts/custumer"
import APIRondas from '../../../services/APIRondas';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  BarElement
} from 'chart.js';



import {
  ContentFilter,
  Section,
  RowContainer
} from "./styles"
import { IRelacaoRondaResponse, IRelacaoRondasBody } from '../../../@interfaces';
import LabelEmptyData from '../../../components/labelemptydata';
import { IStorageFilter } from '../../../@interfaces';
import { TempStorage } from '../../../storage/temp';
import { useTheme } from 'styled-components';
import ToastContext from '../../../contexts/toast';
import Subtitle from '../../../components/subtitle';
import Text from '../../../components/text';


ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  BarElement
);




const DATE_FORMAT = "YYYY-MM-DD"


const RelacaoRondas: React.FC = () => {

  const dataInicioPadrao = moment().subtract(1, "month").format(DATE_FORMAT);
  const dataFinalPadrao = moment().format(DATE_FORMAT);

  const [openFilter, setOpenFilter] = useState<boolean>(false);
  const [dateIni, setDateIni] = useState(dataInicioPadrao);
  const [dateFim, setDateFim] = useState(dataFinalPadrao);

  const [valoresFiltrados, setValoresFiltrados] = useState<IStorageFilter>({ dataInicial: dataInicioPadrao, dataFinal: dataFinalPadrao });

  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const { id_current_custumer } = useContext(CustumerContext);


  const { showErrorToast } = useContext(ToastContext);


  const theme = useTheme();

  useEffect(() => {
    if (id_current_custumer && id_current_custumer > 0) {
      const tempStorage = new TempStorage();
      const storageFilter = tempStorage.getRelacaRondaFilter();

      if (storageFilter) {
        const { dataFinal, dataInicial } = storageFilter;
        setDateFim(dataFinal);
        setDateIni(dataInicial)
      }

      getData(storageFilter)
    }
  }, [id_current_custumer]);




  async function getData(objDate?: IStorageFilter | null) {
    try {

      setLoading(true)

      let ini = dateIni, fim = dateFim;

      if (objDate) {
        ini = objDate.dataInicial;
        fim = objDate.dataFinal;
      }

      const body: IRelacaoRondasBody = {
        cliente: id_current_custumer,
        dataFinal: moment(fim).format("YYYYMMDD"),
        dataInicial: moment(ini).format("YYYYMMDD")
      }

      const response: IRelacaoRondaResponse = await APIRondas.getRelacaoRondas(body);

      setLoading(false)

      if (!response.error) {
        const { concluidas, perdidas, interrompidas, offLine, concluidasOffline } = response;

        if (!concluidas && !perdidas && !interrompidas && !offLine) {
          return setData(null);
        }


        let _labels = [], _backgroundColor = [], _borderColor = [], _data = [];

        if (concluidas! > 0) {
          _labels.push("Concluídas");
          _backgroundColor.push(theme.colors.primary);
          _borderColor.push(theme.colors.blue);
          _data.push(concluidas);
        }

        if (perdidas! > 0) {
          _labels.push("Perdidas");
          _backgroundColor.push(theme.colors.lightPink);
          _borderColor.push(theme.colors.pink);
          _data.push(perdidas);
        }

        if (interrompidas! > 0) {
          _labels.push("Interrompidas");
          _backgroundColor.push(theme.colors.greenyGray);
          _borderColor.push(theme.colors.pine);
          _data.push(interrompidas);
        }

        if (offLine! > 0) {
          _labels.push("Offline");
          _backgroundColor.push(theme.colors.creamYellow);
          _borderColor.push(theme.colors.royalYellow);
          _data.push(offLine)
        }

        if (concluidasOffline! > 0) {
          _labels.push("Concluída Offline");
          _backgroundColor.push(theme.colors.lightOrange);
          _borderColor.push(theme.colors.orange);
          _data.push(concluidasOffline)
        }

        const data = {
          labels: _labels,
          datasets: [
            {
              data: _data,
              backgroundColor: _backgroundColor,
              borderColor: _borderColor,
              borderWidth: 1,
            },
          ],
        }
        setData(data);
      }
    } catch (error) {
      setLoading(false)
      throw new Error("getRelacaoRondas: " + error);
    }
  }





  function showFilter() {
    setOpenFilter(true);
  }

  function handleDateIni(e: React.FormEvent<HTMLInputElement>) {
    setDateIni(e.currentTarget.value)
  }

  function handleDateFim(e: React.FormEvent<HTMLInputElement>) {
    setDateFim(e.currentTarget.value);
  }


  function cleanFilters() {
    setDateIni(moment().subtract(1, "month").format(DATE_FORMAT))
    setDateFim(moment().format(DATE_FORMAT))
  }




  function applyFilter() {
    if (moment(dateFim).isBefore(dateIni)) {
      showErrorToast("Data final inferior a inicial");
      return;
    }

    const tempStorage = new TempStorage();
    tempStorage.setRelacaRondaFilter(dateIni, dateFim);
    setOpenFilter(false);
    setValoresFiltrados({ dataInicial: dateIni, dataFinal: dateFim })
    getData();
  }





  function closeFilter() {
    setDateIni(valoresFiltrados.dataInicial);
    setDateFim(valoresFiltrados.dataFinal)
    setOpenFilter(false)
  }



  return (
    <>
      {openFilter && (
        <ModalFilters handleClose={closeFilter} applyFilter={applyFilter} cleanFilter={cleanFilters}>
          <ContentFilter>
            <Subtitle className='!text-[16px] !mb-4'>Período</Subtitle>
            <Section>
              <InputDate
                onChange={handleDateIni}
                value={dateIni}
                max={dateFim}
                label="Início"
                inputStyle={{ width: 160, background: '#fff' }}
                containerStyle={{ width: 170 }}
              />

              <InputDate
                onChange={handleDateFim}
                value={dateFim}
                min={dateIni}
                label="Fim"
                inputStyle={{ width: 160, background: '#fff' }}
                containerStyle={{ width: 170 }}
              />
            </Section>
            <SeparatorFilter />
          </ContentFilter>
        </ModalFilters>
      )}

      <BoxContainer title='Rondas' filterButton handleFilterButton={showFilter} loading={loading} gridArea={"rondas"}>
        {data && <div className='w-full max-w-[240px] mx-auto'>
          <Doughnut data={data} options={{ responsive: true, maintainAspectRatio: false }} />
        </div>}

        <RowContainer>
          {<Text className="!text-[.75rem] !mt-4">{moment(valoresFiltrados.dataInicial).format("DD/MM/YYYY")} - {moment(valoresFiltrados.dataFinal).format("DD/MM/YYYY")}</Text>
          }
          {!data && <LabelEmptyData style={{ marginTop: 20 }}>
            Nenhum dado a ser exibido
          </LabelEmptyData>}
        </RowContainer>
      </BoxContainer>
    </>
  )
}

export default RelacaoRondas;

